<template lang="pug">
ValidationObserver(ref='form' v-slot='{ valid }')
  envelope-step-bar(:runBeforeNavigate='saveContact' :step='2')
  .alert-template.w-100.d-flex.flex-column.justify-content-center.mb-3(
    v-if='hasEmptyRecipients && hasRecipient && !isTemplate'
  )
    span.ms-3 {{ $t('modal.envelope.updateRecipients') }}
  form(v-if='hasRecipient')
    //- Start - Recipients
    .mb-3(v-if='recipients.length > 1')
      .form-check.form-switch(style='line-height: 1.9em')
        label.form-check-label(for='order') {{ $t('modal.envelope.signatureOrder') }}
        input#order.ms-3.form-check-input(
          @change='recipientsOrder.updated = true'
          type='checkbox'
          v-model='recipientsOrder.ordered'
        )
    draggable(
      :animation='200'
      :disabled='!recipientsOrder.ordered'
      :forceFallback='true'
      :list='recipients'
      :preventOnFilter='false'
      @change='recipientsOrder.updated = true'
      filter='.disableDraggable'
      ghost-class='moving-card'
    )
      .card.card--rounded.flex-row.mb-5(
        :key='recipient.id'
        v-bind:style='{ cursor: recipientsOrder.ordered ? "move" : "default" }'
        v-for='(recipient, index) in recipients'
      )
        .order-recipient.d-flex.flex-column(v-if='recipientsOrder.ordered')
          .mt-1
            icon.icon(name='grip-dots-vertical')
          .text {{ index + 1 }}°
        .card-body
          .row
            label.role-label-edit-envelope(
              v-if='recipient.role && !isTemplate'
            ) {{ recipient.role }}
            .col-12.form-group(v-if='enabledRecipientRole')
              ValidationProvider(
                :rules='{ required: false }'
                :skip-if-empty='!isTemplate'
                :vid='"vp-role-" + index'
                mode='eager'
                name='role'
                v-slot='{ errors }'
              )
                label(for='role') {{ $t('modal.envelope.role') }}
                .form-control-icon
                  icon(name='id-badge')
                  input#role.form-control.disableDraggable(
                    :placeholder='$t("modal.envelope.recipientRolePlaceholder")'
                    @change='recipient.updated = true'
                    autocomplete='off'
                    type='text'
                    v-model='recipient.role'
                  )
            .col-12.col-md-6.form-group
              ValidationProvider(
                :custom-messages='customMessagesName'
                :rules='{ required: !isTemplate || !!getAddressValue(recipient) }'
                :skip-if-empty='isTemplate && !getAddressValue(recipient)'
                :vid='"vp-name-" + index'
                mode='eager'
                name='nome'
                v-slot='{ errors }'
              )
                label(for='name') {{ $t('modal.envelope.name') }}*
                .form-control-icon
                  icon(name='user')
                  input#name.form-control.disableDraggable(
                    :class='{ "border border-danger": errors[0] }'
                    :disabled='inputAddMeDisabled(recipient)'
                    :placeholder='$t("modal.envelope.recipientNamePlaceholder")'
                    @change='recipient.updated = true'
                    autocomplete='off'
                    type='text'
                    v-model='recipient.name'
                  )
                small.align-items-center.text.text-danger.d-flex(
                  v-if='errors.length > 0'
                )
                  icon(name='xmark')
                  span.text.ms-2 {{ errors[0] }}
              .d-flex.align-items-center.gap-3.mt-2(
                v-if='!isTemplate && recipient.requestedAction === "signer"'
              ) 
                .form-check
                  input.form-check-input(
                    :id='`ask-by-photo-${recipient.id}`'
                    @change='recipient.updated = true'
                    type='checkbox'
                    v-model='recipient.photo'
                    value='true'
                  )
                  label.form-check-label(:for='`ask-by-photo-${recipient.id}`') {{ $t('modal.envelope.requirePhoto') }}
            .col-12.col-md-6.form-group
              ValidationProvider(
                :custom-messages='customMessagesRecipient'
                :vid='"vp-recipient-" + index'
                mode='eager'
                name='recipient'
                rules='required'
                v-slot='{ errors }'
              )
                label(for='name') {{ $t('modal.envelope.recipientType') }}*
                div(@click='onClickSignatureType(recipient)')
                  aol-select.disableDraggable(
                    :class='{ "border border-danger": errors[0] }'
                    :options='typeOfRecipients'
                    :placeholder='$t("modal.envelope.selectOption")'
                    :reduce='(type) => type.id'
                    @input='recipient.updated = true'
                    label='title'
                    v-model='recipient.requestedAction'
                  )
                    template(v-slot:no-options='{}')
                      span.text {{ $t('modal.envelope.noRecipientTypeFound') }}
                    template(v-slot:selected-option='{ title, icon }')
                      icon(:name='icon')
                      span.text {{ title }}
                    template(v-slot:option='{ title, icon }')
                      icon(:name='icon')
                      span.text {{ title }}
                    template(v-slot:prepend='{}')
                      icon(:name='icon')
                small.align-items-center.text.text-danger.d-flex(
                  v-if='errors.length > 0'
                )
                  icon(name='xmark')
                  span.text.ms-2 {{ errors[0] }}
            .col-12.col-md-6.form-group
              label(for='email') {{ shippingTitle }}
              label(v-if='hasFeatureWhatsapp')
                input.mx-2.form-check-input(
                  checked
                  type='radio'
                  v-model='recipient.shippingType'
                  value='email'
                )
                | {{ $t('modal.envelope.emailAddress') }}
                input.mx-2.form-check-input(
                  type='radio'
                  v-model='recipient.shippingType'
                  value='whatsapp'
                )
                | {{ $t('modal.envelope.whatsapp') }}
              ValidationProvider(
                :custom-messages='customMessagesEmail'
                :rules='{ required: !isTemplate || hasName(recipient), email: true, uniqueAddressesInEnvelope: recipients }'
                :skip-if-empty='isTemplate && !hasName(recipient)'
                :vid='"vp-shipping-" + index'
                key='email'
                mode='eager'
                name='e-mail'
                v-if='!isPhoneShipping(recipient)'
                v-slot='{ errors }'
              )
                .form-control-icon
                  icon(name='at')
                  input#email.form-control.disableDraggable(
                    :class='{ "border border-danger": errors[0] }'
                    :disabled='inputAddMeDisabled(recipient)'
                    :placeholder='$t("modal.envelope.recipientEmailPlaceholder")'
                    @change='recipient.updated = true'
                    autocomplete='off'
                    v-model='recipient.email'
                  )
                small.align-items-center.text.text-danger.d-flex(
                  v-if='errors.length > 0'
                )
                  icon(name='xmark')
                  span.text.ms-2 {{ errors[0] }}
              ValidationProvider(
                :custom-messages='customMessagePhone'
                :key='"whatsapp-" + index'
                :rules='{ required: !isTemplate || hasName(recipient), intBrazilianPhone: isBrazilPhone, uniqueAddressesInEnvelope: recipients }'
                :skip-if-empty='isTemplate && !hasName(recipient)'
                :vid='"vp-shipping-" + index'
                name='phone'
                v-if='isPhoneShipping(recipient)'
                v-slot='{ errors }'
              )
                .form-control-icon
                  input-tel#phone.form-control.disableDraggable(
                    :class='{ "border border-danger": errors[0] }'
                    :disabled='inputAddMeDisabled(recipient)'
                    :placeholder='$t("modal.envelope.recipientPhonePlaceholder")'
                    @change='recipient.updated = true'
                    @is-brazil-changed='isBrazilPhone = $event'
                    autocomplete='off'
                    type='text'
                    v-model='recipient.phone'
                  )
                small.align-items-center.text.text-danger.d-flex(
                  v-if='errors.length > 0'
                )
                  icon(name='xmark')
                  span.text.ms-2 {{ errors[0] }}
            .col-12.col-md-6.form-group(
              v-if='recipient.requestedAction === "signer"'
            )
              label(for='name') {{ $t('modal.envelope.signatureType') }}*
              aol-select(
                :options='authOptions'
                :placeholder='$t("modal.envelope.selectOption")'
                :reduce='(type) => type.id'
                @input='recipient.updated = true'
                label='title'
                v-model='recipient.authType'
              )
                template(v-slot:no-options='{}') {{ $t('modal.envelope.noSignatureTypeFound') }}
                template(v-slot:selected-option='{ title, icon, id }')
                  icon(:name='icon')
                  span.text {{ title }}
                template(v-slot:option='{ title, icon, id }')
                  icon(:name='icon')
                  span.text {{ title }}
                template(v-slot:prepend='{}')
                  icon(:name='icon')
            .col-12.form-group.text-end.mb-0
              button.link--delete-recipient(
                @click='removeRecipientConfirmation(recipient)'
                type='button'
              )
                icon.default(name='trash')
                icon.hover(name='trash')
                span.ms-2.text {{ $t('modal.envelope.deleteRecipient') }}
  .text-center.mt-5(v-else)
    img.img(src='/img/ilustrations/no-recipient.svg')
    p.mt-4 {{ $t('modal.envelope.noRecipientAdded') }}
  .d-flex(
    :style='hasRecipient ? "margin-top: -23px" : ""'
    style='margin-bottom: 90px'
    v-bind:class='hasRecipient ? "justify-content-between" : "justify-content-center"'
  )
    button.btn.btn-thin(
      :disabled='hasDuplicateAddresses'
      @click='addEmptyRecipient'
      aria-expanded='false'
      type='button'
      v-if='isTemplate'
    )
      span.text {{ $t('modal.envelope.add') }}
    .dropdown-stylized.dropdown-stylized--with-border(
      :class='{ disabled: hasDuplicateAddresses }'
      v-else
    )
      button(
        :disabled='hasDuplicateAddresses'
        aria-expanded='false'
        data-bs-toggle='dropdown'
        type='button'
      )
        span.text {{ $t('modal.envelope.add') }}
        icon.arrow(name='angle-down')
      .dropdown-menu(aria-labelledby='productsDropdown')
        ul
          li
            button.dropdown-item(@click='addEmptyRecipient' type='button')
              .text {{ $t('modal.envelope.individualRecipient') }}
          li(:hidden='hasAddedMe')
            button.dropdown-item(@click='addUserAsRecipient' type='button') {{ $t('modal.envelope.addMe') }}
          li
            button.dropdown-item(
              data-bs-target='#contact-loader-modal'
              data-bs-toggle='modal'
              type='button'
            ) {{ $t('pages.contacts.contactList') }}
    small.align-items-center.text.text-danger.d-flex(
      v-if='hasDuplicateAddresses'
    )
      icon(name='xmark')
      span.text.ms-2 {{ $t('validations.uniqueAddressesInEnvelope') }}
  envelope-bottom-bar(
    :disableButtonNextStep='!valid || disabledButtonNextStep'
    :disabledSubmitReview='hasNewRecipientsWithoutAddressee'
    :discardAndClose='isTemplate'
    :showSubmitToReviewButton='submitToReviewAvailable'
    @discardAndClose='discardChanges'
    @nextStep='nextStep'
    @openSubimitToReview='openSubmitToReview'
    @saveAndClose='saveAndClose'
  )
  contact-loader-modal#contact-loader-modal(
    @selected-contacts='addContactsAsRecipient'
  )
  no-subscriber-modal(ref='noSubscriberModal')
  warning-discard-and-close-envelope-modal(
    @discardChanges='discardChanges'
    ref='discardAndCloseModal'
  )
  warning-save-and-close-envelope-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='warningSaveAndCloseEnvelopeModal'
  )
    p.mb-0 {{ $t('modal.envelope.discardRecipients') }}
  onboarding-recipient-modal(
    @finished='updateOnboarding({ onboardingName: "business_envelope_recipient", value: true })'
    ref='onboardingRecipientModal'
  )
  delete-recipient-modal(
    @process='removeRecipient(selectedRecipientRemove)'
    ref='deleteRecipientModal'
  )
  change-type-signer-modal(ref='changeTypeSignerModal')
  submit-envelope-to-review-modal(
    :envelope='envelope'
    :visibilityOptions='visibilityOptionsForModal'
    :visibilitySelected='currentVisibilityValue'
    @envelope-submitted-to-review='openEnvelopeSubmittedToReviewModal'
    ref='submitEnvelopeToReviewModal'
  )
  envelope-submitted-to-review-modal(ref='envelopeSubmittedToReviewModal')
  warning-change-envelope-reviewer-modal(
    @changeEnvelopeReviewer='changeEnvelopeReviewer'
    ref='changeEnvelopeReviewerModal'
  )
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import ContactLoaderModal from '@/ui/organisms/modals/ContactLoaderModal.vue';
import NoSubscriberModal from '@/modules/business/components/organisms/modals/NoSubscriberModal.vue';
import OnboardingRecipientModal from '@/modules/business/components/organisms/modals/OnboardingRecipientModal.vue';
import Draggable from 'vuedraggable';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import RecipientType from '@/enums/RecipientType';
import EnvelopeState from '@/enums/EnvelopeState';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import ContactService from '@/modules/account/services/http/ContactsService';
// eslint-disable-next-line max-len
import WarningSaveAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseEnvelope.vue';
import EnvelopeStepBar from '@/ui/organisms/EnvelopeStepBar.vue';
import DeleteRecipientModal from '@/modules/business/components/organisms/modals/DeleteRecipientModal.vue';
import ChangeTypeSignerModal from '@/modules/business/components/organisms/modals/ChangeTypeSignerModal.vue';
import { mapGetters, mapActions } from 'vuex';
import InputTel from '@/ui/molecules/InputTel.vue';
import alert from '@/modules/account/common/alert';
import WarningDiscardAndCloseEnvelopeModal from '@/modules/business/components/organisms/modals/WarningDiscardAndCloseEnvelopeModal.vue';
import {
  getAllowedVisibilities,
  getCurrentVisibilityValue,
  getVisibilityOptions,
} from '@/modules/business/common/envelopeVisibility';
import {
  isPhoneVia,
  recipientAddress,
  recipientAddressValue,
} from '@/utils/ValidateRules';
import SubmitEnvelopeToReviewModal from '@/modules/business/components/organisms/modals/SubmitEnvelopeToReviewModal.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import EnvelopeSubmittedToReviewModal from '@/modules/business/components/organisms/modals/EnvelopeSubmittedToReviewModal.vue';
import Logger from '@/services/Logger';
import WarningChangeEnvelopeReviewerModal from '@/modules/business/components/organisms/modals/WarningChangeEnvelopeReviewerModal.vue';

const recipientModel = {
  name: '',
  email: '',
  requestedAction: '',
  authType: 'default',
  isInvalid: false,
  errors: {},
  inServer: false,
  role: '',
};

export default {
  name: 'RecipientsEnvelopePage',
  components: {
    WarningChangeEnvelopeReviewerModal,
    EnvelopeSubmittedToReviewModal,
    ContactLoaderModal,
    Icon,
    Draggable,
    NoSubscriberModal,
    EnvelopeBottomBar,
    WarningSaveAndCloseEnvelopeModal,
    WarningDiscardAndCloseEnvelopeModal,
    EnvelopeStepBar,
    OnboardingRecipientModal,
    DeleteRecipientModal,
    ChangeTypeSignerModal,
    InputTel,
    SubmitEnvelopeToReviewModal,
  },
  data() {
    return {
      hasEmptyRecipients: false,
      recipientsOrder: {
        updated: false,
        ordered: false,
      },
      isBrazilPhone: true,
      envelopeState: '',
      envelope: null,
      recipients: [],
      documents: [],
      teams: [],
      teamsLoaded: false,
      error: false,
      loading: false,
      nextRoute: null,
      selectedRecipientRemove: {},
      customMessagesName: {
        required: this.$t('modal.envelope.nameRequired'),
      },
      customMessagesEmail: {
        required: this.$t('modal.envelope.emailRequired'),
        email: this.$t('modal.envelope.validEmailRequired'),
      },
      customMessagePhone: {
        required: this.$t('modal.envelope.phoneRequired'),
      },
      customMessagesRecipient: {
        required: this.$t('modal.envelope.recipientTypeRequired'),
      },
      typeOfRecipients: [
        {
          id: 'signer',
          title: this.$t('modal.envelope.signer'),
          icon: 'signature',
        },
        {
          id: 'approver',
          title: this.$t('modal.envelope.approver'),
          icon: 'user-check',
        },
        {
          id: 'carbon-copy',
          title: this.$t('modal.envelope.viewer'),
          icon: 'eye',
        },
      ],
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.envelope.documents' ||
      to.name === 'business.envelope.fields' ||
      to.name === 'business.documents.waiting-review' ||
      to.name === 'business.documents.draft'
    ) {
      next();
      return;
    }
    if (this.isTemplate) {
      this.$refs.discardAndCloseModal.$refs.modal.open();
      this.nextRoute = next;
      return;
    }
    this.$refs.warningSaveAndCloseEnvelopeModal.$refs.modal.open();
    this.nextRoute = next;
  },
  watch: {
    recipientsCopy(newArray, oldArray) {
      if (this.loading) {
        return;
      }

      if (newArray.length === 1) {
        this.recipientsOrder.ordered = false;
        return;
      }

      if (oldArray.length > newArray.length) {
        return;
      }

      if (
        oldArray.length <= 1 &&
        newArray.length >= 2 &&
        this.hasRecipientOrder
      ) {
        this.recipientsOrder.ordered = true;
        return;
      }
    },
  },
  created() {
    let pageTitle = this.getPageTitle;
    const self = this;
    if (this.$route.params.isNew) {
      pageTitle = self.$t('modal.envelope.newEnvelope');
    }
    this.updateOnboarding({
      onboardingName: 'business_envelope_recipient',
      value: true,
    });
    this.$store.dispatch('page/setTitle', pageTitle);
    this.$store.dispatch('page/setHead', {
      title: pageTitle,
      action() {
        self.$router.replace({
          name: 'business.envelope.documents',
          params: {
            id: self.$route.params.id,
            isNew: self.$route.params.isNew,
          },
        });
      },
      help() {
        self.$refs.onboardingRecipientModal.$refs.modal.open();
      },
    });
  },
  async beforeMount() {
    this.loading = true;
    try {
      const res = await EnvelopesService.getExtendedEnvelope(
        this.$route.params.id
      );
      this.envelope = res.data;
      this.envelopeState = res.data.state;
      this.documents = res.data.documents;
      await this.fetchTeams();
      if (res.data.recipients.length > 0) {
        const r = res.data.recipients.map((data) => {
          const recipient = data;
          recipient.inServer = true;
          recipient.changeRequestedActionWarned = false;
          recipient.requestedAction = recipient.type;
          recipient.authType = recipient.signature_type;
          recipient.role = recipient.role || '';
          recipient.name = '';
          recipient.email = '';
          const addressee = recipient.addressees?.[0];
          const addresseeVia = addressee?.via ?? 'email';
          const isPhoneAddressee =
            isPhoneVia(addresseeVia) &&
            (this.hasFeatureWhatsapp || !this.isTemplate);
          if (addressee) {
            recipient.name = addressee.name;
            if (isPhoneAddressee) {
              recipient.phone = addressee.value;
            } else {
              recipient.email = addressee.value;
            }
            const recipientPhoto = (addressee.identifiers ?? []).find(
              (i) => i.code === 'PHOTO'
            );
            recipient.photo = recipientPhoto ? recipientPhoto.is_required : '';
          }
          recipient.shippingType = isPhoneAddressee ? addresseeVia : 'email';
          return recipient;
        });
        this.recipients = await this.recipients.concat(r);

        this.recipients.sort((a, b) => {
          return a.routing_order - b.routing_order;
        });
        const emptyRecipientsCount = this.recipients.reduce(
          (count, recipient) => {
            if (recipient.name === '') {
              return count + 1;
            }
            return count;
          },
          0
        );
        this.hasEmptyRecipients = emptyRecipientsCount;
        this.$nextTick(() => {
          this.recipientsOrder.ordered = true;
          if (res.data.recipients[0].routing_order === null) {
            this.recipientsOrder.ordered = false;
          }
        });
      }
    } catch (err) {
      console.error('Error loading extended envelope:', err);
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    if (!this.getOnboarding('business_envelope_recipient')) {
      this.$refs.onboardingRecipientModal.$refs.modal.open();
    }
  },
  computed: {
    ...mapGetters({ getOnboarding: 'onboardings/getOnboarding' }),
    hasAtLeastOneSigner() {
      return this.recipients.some(
        (recipient) => recipient.requestedAction === RecipientType.SIGNER
      );
    },
    allRecipientsInServer() {
      return this.recipients.every((recipient) => recipient.inServer === true);
    },
    hasNewInvalidRecipients() {
      return this.recipients.some(
        (recipient) =>
          recipient.inServer !== true &&
          (!this.hasName(recipient) || !this.getAddressValue(recipient))
      );
    },
    hasRecipient() {
      return this.recipients.length > 0;
    },
    hasNewRecipientsWithoutAddressee() {
      if (!this.hasRecipient) {
        return false;
      }
      if (this.allRecipientsInServer && !this.hasDuplicateAddresses) {
        return false;
      }
      return this.hasNewInvalidRecipients || this.hasDuplicateAddresses;
    },
    hasDuplicateAddresses() {
      if (!this.hasRecipient || this.recipients.length === 1) {
        return false;
      }
      const addresses = this.recipients
        .map(recipientAddress)
        .filter((address) => address && address.length > 0);
      const uniqueAddresses = new Set(addresses);
      return uniqueAddresses.size !== addresses.length;
    },
    hasAddedMe() {
      if (!this.hasRecipient) {
        return false;
      }
      return this.recipients.some(
        (recipient) =>
          recipient.email === this.$root.user.email &&
          recipient.name === this.$root.user.name
      );
    },
    disabledButtonNextStep() {
      return !this.hasRecipient;
    },
    submitToReviewAvailable() {
      const allowedVisibilities = getAllowedVisibilities(
        this.$store.state.organizations.selected
      );
      return (
        this.envelopeState === EnvelopeState.DRAFT &&
        allowedVisibilities.length > 0
      );
    },
    recipientsCopy() {
      return this.recipients.slice();
    },
    hasEnvelopeFields() {
      return this.documents.reduce((fieldsCount, document) => {
        return fieldsCount + document.fields.length;
      }, 0);
    },
    availableVisibilities() {
      return getAllowedVisibilities(this.$store.state.organizations.selected);
    },
    visibilityOptionsForModal() {
      return getVisibilityOptions({
        visibilities: this.availableVisibilities,
        teams: this.teams,
        translate: (key) => this.$t(key),
      });
    },
    currentVisibilityValue() {
      return getCurrentVisibilityValue(this.envelope);
    },
    hasFeatureWhatsapp() {
      if (this.$root.isUSAVersion) {
        return false;
      }

      if (this.$store.getters['subscription/isPostpaid']) {
        return true;
      }

      const feature = this.$store.state.subscription.plan.plan.features
        .filter((i) => i.feature === 'whatsapp')
        .shift();
      if (!feature) {
        return false;
      }
      return !!feature.feature;
    },
    shippingTitle() {
      return this.hasFeatureWhatsapp
        ? this.$t('recipients.shippingTitle.sendEnvelope')
        : this.$t('recipients.shippingTitle.emailAddress');
    },
    hasRecipientOrder() {
      const organizationSelected = this.$store.state.organizations.selected;
      const recipientOrder =
        organizationSelected?.metadata['envelope.recipient.order'] ?? true;
      return recipientOrder;
    },
    hasExplicitOrder() {
      return this.recipientsOrder.ordered || this.recipients.length === 1;
    },
    authOptions() {
      const SIGNATURE_TYPE_KEY = 'envelope.recipient.signature.type';

      const allOptions = [
        {
          id: 'simple',
          title: this.$t('modal.envelope.simpleSignature'),
          icon: 'file-contract',
        },
        {
          id: 'qualified',
          title: this.$t('modal.envelope.qualifiedSignature'),
          icon: 'shield',
        },
      ];

      if (this.$root.isUSAVersion) {
        return allOptions.filter(({ id }) => id === 'simple');
      }

      const signatureType =
        this.$store.state.organizations.selected?.metadata[
          SIGNATURE_TYPE_KEY
        ] ?? null;

      return signatureType
        ? allOptions.filter(({ id }) => id === signatureType)
        : allOptions;
    },
    isWaitingReview() {
      return this.envelopeState === EnvelopeState.WAITING_REVIEW;
    },
    isTemplate() {
      return (
        this.$route.params.isTemplate == true ||
        this.envelopeState === 'template'
      );
    },
    isNewTemplate() {
      return this.isTemplate && this.$route.params.isNewTemplate == true;
    },
    getPageTitle() {
      if (this.isNewTemplate) {
        return this.$t('newTemplate');
      } else if (this.isTemplate) {
        return this.$t('editTemplate');
      }
      return this.$t('editEnvelope');
    },
    canUseBulkSend() {
      // TODO: a definir se a funcionalidade de bulk send será habilitada via plano ou metadata da organização
      return true;
    },
    enabledRecipientRole() {
      return this.isTemplate && this.canUseBulkSend;
    },
  },
  methods: {
    ...mapActions({ updateOnboarding: 'onboardings/updateOnboarding' }),
    async validateForm() {
      const resultValidate = await this.$refs.form.validate();
      return resultValidate;
    },
    async addEmptyRecipient() {
      this.addRecipient('', '');
    },
    async addUserAsRecipient() {
      if (this.hasAddedMe) {
        alert.fireAlert(`${this.$t('validations.uniqueAddressesInEnvelope')}`, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'circle-exclamation',
        });
        return;
      }
      this.addRecipient(
        this.$root.user.name,
        this.$root.user.email,
        this.$root.user.phone
      );
    },
    async addContactsAsRecipient(contacts) {
      contacts.forEach((contact) => {
        this.addRecipient(
          contact.name,
          contact.email,
          contact.phone,
          contact.id
        );
      });
    },
    addRecipient(name, email, phone, contactId) {
      const recipient = { ...recipientModel };
      recipient.id = Math.floor(Math.random() * 10000);
      recipient.name = name;
      recipient.email = email;
      recipient.phone = phone;
      recipient.inServer = false;
      recipient.shippingType =
        this.hasFeatureWhatsapp && phone && !email ? 'whatsapp' : 'email';
      recipient.requestedAction = this.typeOfRecipients[0].id;
      recipient.authType = this.authOptions[0].id;
      recipient.contactId = contactId;
      this.recipients.push(recipient);
    },
    removeRecipientConfirmation(recipient) {
      if (!this.hasEnvelopeFieldsByRecipient(recipient)) {
        this.removeRecipient(recipient);
        return;
      }
      this.selectedRecipientRemove = recipient;
      this.$refs.deleteRecipientModal.$refs.modal.open();
    },
    async removeRecipient(recipient) {
      try {
        if (recipient.inServer) {
          await EnvelopesService.removeRecipient(
            this.$route.params.id,
            recipient.id
          );
        }
        this.recipients = this.recipients.filter(
          (item) => item.id !== recipient.id
        );
      } catch (e) {
        const apiMessage = e.response?.data?.message;
        let message = apiMessage
          ? apiMessage
          : this.$t('http.defaultError') + ' : ' + e.message;
        alert.fireAlert(message, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'circle-exclamation',
        });
      }
    },
    validateRecipients() {
      return this.recipients.find(
        (recipient) => recipient.requestedAction === RecipientType.SIGNER
      );
    },
    getAddressValue(recipient) {
      return recipientAddressValue(recipient)?.trim() ?? '';
    },
    isPhoneShipping(recipient) {
      return isPhoneVia(recipient.shippingType);
    },
    hasName(recipient) {
      return !!recipient.name?.trim();
    },
    buildAddressees(recipient) {
      const identifiers = [
        {
          code: 'PHOTO',
          is_required: !!recipient.photo,
        },
      ];
      if (!this.isTemplate) {
        return [
          {
            via: recipient.shippingType,
            value: recipientAddressValue(recipient),
            name: recipient.name,
            identifiers,
          },
        ];
      }
      const name = recipient.name?.trim() ?? '';
      const value = recipientAddressValue(recipient)?.trim() ?? '';
      if (!name && !value) {
        return [];
      }
      if (!name || !value) {
        // par incompleto: não sincroniza addressees para não apagar o gravado
        return null;
      }
      return [
        {
          via: recipient.shippingType,
          value,
          name,
          identifiers,
        },
      ];
    },
    buildRecipientPayload(recipient, order) {
      if (recipient.requestedAction !== RecipientType.SIGNER) {
        recipient.photo = false;
      }
      const addressees = this.buildAddressees(recipient);
      const data = {
        type: recipient.requestedAction,
        signature_type: recipient.authType,
        role: this.canUseBulkSend && recipient.role ? recipient.role : '',
        routing_order: null,
      };

      if (addressees !== null) {
        data.addressees = addressees;
      }

      if (this.hasExplicitOrder) {
        data.routing_order = order;
      }

      return data;
    },
    showRecipientErrorMessage(message) {
      alert.fireAlert(message, {
        classes: 'alert-danger',
        styles:
          'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
        tag: 'httpAlert',
        icon: 'circle-exclamation',
      });
    },
    handleRecipientSaveError(err) {
      if (err.response?.status !== 422) {
        return;
      }
      const message =
        err.response.data.message ?? this.$t('modal.editRecipient.error');
      this.showRecipientErrorMessage(message);
    },
    addRecipientOnEnvelope(recipient, order) {
      return new Promise((resolve, reject) => {
        const data = this.buildRecipientPayload(recipient, order);

        if (
          recipient.updated &&
          this.$root.user.email != recipient.email &&
          recipient.contactId
        ) {
          ContactService.update(recipient.contactId, {
            name: recipient.name,
            email: recipient.email,
            phone: recipient.phone,
          });
        }
        EnvelopesService.addRecipient(this.$route.params.id, data)
          .then((response) => {
            const serverId = response.data?.id;
            if (!serverId) {
              this.showRecipientErrorMessage(
                this.$t('modal.editRecipient.error')
              );
              reject(new Error('Recipient created without id'));
              return;
            }
            recipient.id = serverId;
            recipient.inServer = true;
            recipient.updated = false;
            resolve();
          })
          .catch((err) => {
            this.handleRecipientSaveError(err);
            reject(err);
          });
      });
    },
    updateRecipientOnEnvelope(recipient, order) {
      return new Promise((resolve, reject) => {
        const data = this.buildRecipientPayload(recipient, order);

        EnvelopesService.updateRecipient(
          this.$route.params.id,
          recipient.id,
          data
        )
          .then(() => {
            recipient.updated = false;
            resolve();
          })
          .catch((err) => {
            this.handleRecipientSaveError(err);
            reject(err);
          });
      });
    },
    onClickSignatureType(recipient) {
      if (
        !this.hasEnvelopeFieldsByRecipient(recipient) ||
        recipient.changeRequestedActionWarned ||
        !recipient.inServer
      ) {
        return;
      }
      this.$refs.changeTypeSignerModal.$refs.modal.open();
      recipient.changeRequestedActionWarned = true;
    },
    getSaveRecipientTask(recipient, order) {
      const hasAddress =
        this.isTemplate || recipient.email !== '' || recipient.phone !== '';
      const hasAction = recipient.requestedAction !== '';
      if (!hasAddress || !hasAction) {
        return null;
      }
      if (!recipient.inServer) {
        return () => this.addRecipientOnEnvelope(recipient, order);
      }
      if (recipient.updated || this.recipientsOrder.updated) {
        return () => this.updateRecipientOnEnvelope(recipient, order);
      }
      return null;
    },
    async saveContact() {
      if (
        this.isTemplate &&
        this.hasRecipient &&
        !(await this.validateForm())
      ) {
        return false;
      }
      this.$loading(true);
      try {
        const hasExplicitOrder = this.hasExplicitOrder;
        const promises = [];
        let requestIndex = 0;
        for (let i = 0; i < this.recipients.length; i += 1) {
          const recipient = this.recipients[i];
          const saveRecipientTask = this.getSaveRecipientTask(recipient, i + 1);
          if (!saveRecipientTask) {
            continue;
          }

          if (hasExplicitOrder) {
            promises.push(saveRecipientTask());
            continue;
          }

          // when no have explicit order
          promises.push(
            new Promise((resolve) => {
              setTimeout(resolve, requestIndex * 200);
            }).then(() => saveRecipientTask())
          );
          // incremented only when no have explicit order
          requestIndex += 1;
        }

        await Promise.all(promises);
        this.recipientsOrder.updated = false;
        return true;
      } finally {
        this.$loading(false);
      }
    },
    async changeEnvelopeReviewer(event) {
      if (event === true) {
        try {
          this.$loading(true);
          await EnvelopesService.releaseEnvelopeReview(this.$route.params.id);
        } catch (error) {
          Logger.consoleError('Error to release envelope review', error);
        } finally {
          this.$loading(false);
        }
      }
      await this.$router.push({ name: 'business.documents.waiting-review' });
    },
    async saveAndClose() {
      if (this.hasDuplicateAddresses) {
        this.error = true;
        alert.fireAlert(`${this.$t('validations.uniqueAddressesInEnvelope')}`, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'circle-exclamation',
        });
        return;
      }
      try {
        const saved = await this.saveContact();
        if (!saved) {
          return;
        }
      } catch (e) {
        return;
      }

      if (this.isWaitingReview) {
        this.$refs.changeEnvelopeReviewerModal.$refs.modal.open();
        return;
      }

      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.draft' });
    },
    async saveDetails() {
      if (!(await this.validateForm())) {
        return false;
      }
      this.error = false;
      const invalidRecipients = this.validateRecipients();
      if (invalidRecipients === undefined) {
        this.$refs.noSubscriberModal.$refs.modal.open();
        return false;
      }
      try {
        const saved = await this.saveContact();
        if (!saved) {
          return false;
        }
      } catch (e) {
        return false;
      }
      return true;
    },
    async nextStep() {
      if (!(await this.saveDetails())) {
        return false;
      }
      this.$router.replace({
        name: 'business.envelope.fields',
        params: {
          id: this.$route.params.id,
          isNew: this.$route.params.isNew,
          isTemplate: this.isTemplate,
          isNewTemplate: this.isNewTemplate,
        },
      });

      return true;
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    inputAddMeDisabled(recipient) {
      if (
        recipient.email === this.$root.user.email &&
        recipient.name === this.$root.user.name
      ) {
        return true;
      }

      return false;
    },
    async openSubmitToReview() {
      try {
        const saved = await this.saveContact();
        if (!saved) {
          return;
        }
      } catch (e) {
        return;
      }
      this.$refs.submitEnvelopeToReviewModal.$refs.modal.open();
    },
    async fetchTeams() {
      if (this.teamsLoaded || !this.availableVisibilities.includes('team')) {
        return;
      }
      try {
        const response = await TeamsService.list();
        this.teams = response.data.data;
        this.teamsLoaded = true;
      } catch {
        this.teams = [];
      }
    },
    openEnvelopeSubmittedToReviewModal() {
      this.$refs.envelopeSubmittedToReviewModal.$refs.modal.open();
    },
    hasEnvelopeFieldsByRecipient(recipient) {
      if (!recipient.inServer) {
        return false;
      }
      let fieldsLength = this.documents.reduce((fieldsCount, document) => {
        return (
          fieldsCount +
          document.fields.reduce((fieldsCountPerDocument, field) => {
            if (field.recipient === recipient.id) {
              return fieldsCountPerDocument + 1;
            }
            return fieldsCountPerDocument;
          }, fieldsCount)
        );
      }, 0);
      return fieldsLength > 0;
    },
  },
};
</script>
<style lang="stylus" scoped>

.card-body
  label
    font-size: 1rem
.alert-template
  color: #01698E
  background-color: #CCEFFB
  height: 3.125rem
  font-weight: bold
  border-radius: 0.313rem
.w-center
  margin: auto
  max-width: 960px
.recipient-order
  position: absolute
  left: -5rem
  top: 0
  bottom: 0
  margin: auto
  background-color: #fff
  width: 4rem
  height: 4rem
  border: 2px solid #f2f2f2
  text-align: center
  line-height: 3.7rem
  border-radius: 50%
  padding: 0em
  font-size: 1.8em
  font-weight: 600
  color: #c3c3c3
  cursor: move
.form-check.form-switch
  display: flex
  padding-left: 0
  .form-check-input
    width: 2.438rem
    &:focus
      box-shadow: none
.link--delete-recipient
  font-size: 1rem
  color: #555555
  .default
    display: inline
  .hover
    display: none
  &:hover
    .default
      display: none
    .hover
      display: inline
.text-danger
  font-size: 1rem
  padding-top: 0.25rem
.role-label-edit-envelope
  color: #013D52
  font-size: 0.875rem
  text-align: start
.order-recipient
  border-top-left-radius: 0.5rem
  border-bottom-left-radius: 0.5rem
  width: 1.625rem
  background-color: #E5EBED
  color: #013D52
  font-size: 0.875rem
  text-align: center
  .icon
    font-size: 1rem
  .text
    font-weight: 600
    margin-top: 5.8rem
.moving-card
  opacity: 0.5
.dropdown-stylized--with-border
  .icon.arrow
    margin: auto 0.875rem !important
    height: auto
  span
    font-weight: 600
.dropdown-stylized--with-border.disabled
  opacity: 1
  pointer-events: none
.dropdown-stylized--with-border.disabled button
  cursor: not-allowed
  background-color: #ccc
  color: #555
  border-color: #ccc !important
  opacity: 1
.dropdown-stylized--with-border.disabled .text
  color: #555 !important
.dropdown-stylized--with-border.disabled .arrow
  color: #555 !important
</style>
